// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yCZj","largestCol":"styles_largestCol__2ySXq","smallestCol":"styles_smallestCol__mg0Ir"};